import { Text } from '@fluentui/react';
import { UserRegistrationPeriod } from '../api/generated/data-contracts';
import { FormatValue, GetTotalFromTimeRowArray } from './Utils';

export const RowTotalCell = ({ projectId, times, allocation }: { projectId: string; times: UserRegistrationPeriod[]; allocation: number }) => {
    const totalForRow = GetTotalFromTimeRowArray(times);
    const totalString = totalForRow != null ? FormatValue(totalForRow) : '';

    // Logic for hoursString:
    // 1. If allocation exists:
    //    - Show totalString if there are recorded hours.
    //    - Otherwise, show '0' to emphasize missing hours.
    // 2. If no allocation:
    //    - Show totalString if there are recorded hours.
    //    - Otherwise, show an empty string.
    const hoursString = allocation ? totalString || '0' : totalString;

    return (
        <Text as="div" className="totalCellInner">
            {hoursString}
        </Text>
    );
};
